import React, { useState } from "react";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import Button from "components/Button";

import CancelModal from "./CancelModal";

import { SubscriptionResponseDto } from "api";

import analytics from "services/analytics";
import { AnalyticsEvents } from "shared/constants/analytics";

interface CancelSubscriptionBlockProps {
  subscription: SubscriptionResponseDto;
}

const CancelSubscriptionBlock: React.FC<CancelSubscriptionBlockProps> = ({
  subscription,
}) => {
  const [isModalOpen, setModalOpen] = useState(false);

  const onOpenModal = () => {
    analytics().sendEvent(AnalyticsEvents.subscription_cancel_subscription);
    setModalOpen(true);
  };

  const onCloseModal = () => {
    setModalOpen(false);
  };

  return (
    <>
      <Box
        data-testid="cancelation-block"
        sx={{ pt: 3, borderTop: "1px solid #E5E5E5", width: "100%" }}
      >
        <Typography variant="body1" sx={{ mb: 0.5 }}>
          Скасувати передплату
        </Typography>
        <Typography variant="body1" color="grey700" sx={{ mb: 1.5 }}>
          Якщо ви хочете припинити використання свого тарифу, ви <br />
          можете скасувати його в будь-який час.
        </Typography>
        <Button
          data-testid="cancel-subscription-button"
          onClick={onOpenModal}
          variant="contained"
          color="error"
          size="medium"
          withBorder
        >
          Скасувати передплату
        </Button>
      </Box>
      <CancelModal
        isOpen={isModalOpen}
        onClose={onCloseModal}
        subscription={subscription}
      />
    </>
  );
};

export default CancelSubscriptionBlock;
